import React  from 'react';
import BlogPostBasicInfoComponent from './blog-post-basic-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';


export const BlogPostComponent = ({mediaFiles,handleFormItemChange,deleteSelectedFile,getIsImageRecordDeletable,changeImage, handleInnerFormChange, selectedBlog,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Blog Post Information',
        component:<BlogPostBasicInfoComponent handleInnerFormChange={handleInnerFormChange}
        selectedBlog={selectedBlog}
        mediaFiles={mediaFiles}
        handleFormItemChange={handleFormItemChange}
        changeImage={changeImage}
        deleteSelectedFile={deleteSelectedFile}
        getIsImageRecordDeletable={getIsImageRecordDeletable}
         />,
    isVisible:true,
    },
    
  ]
    
  return (
    <>   
      <TabContainer tabItems={tabItems} />
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       
    </>
  )
}
export default BlogPostComponent;
